module.exports = __webpack_public_path__ + "016d018eea79e0694f99787ff1245ea3.svg";